import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useUserStore } from "../../../store/userStore.js";


import UserProfileLayout from "../../../components/layout/userprofilelayout/userprofilelayout";
import Spacer from "../../../components/spacer/spacer";
import Loader from "../../../components/loader/loader";

import DocumentView from "./documentview";
import DocumentUpload from "./documentupload";

import images from "../../../assets";
import "./styles.css";

const EditTrustBadge = () => {
  const location = useLocation();
  const { user, isUserLoading, getUser, updateUser } = useUserStore();

  const username = location.pathname.split("/")[2];

  const [trustbadgeData, setTrustbadgeData] = useState([]);

  useEffect(() => {
    getprofileData();
  }, [username]);

  useEffect(() => {
    setTrustbadgeData(user?.trustbadge);
  }, [user]);

  const getprofileData = () => {
    const payload = { username };
    getUser(payload);
  };

  const deleteTrustBadge = (deleteUrl) => {
    const filterDelete = trustbadgeData.filter(
      (item) => item?.url !== deleteUrl
    );

    const updatedTrustBadgeData = filterDelete?.map(
      ({ signedUrl, ...rest }) => rest
    );

    const payload = {
      username,
      data: { trustbadge: updatedTrustBadgeData, trustbadgeStatus: "false" },
    };
    updateUser(payload, () => getprofileData());
  };

  return (
    <UserProfileLayout>
      <div className="edit-profile-container">
        <Spacer height="32px" />
        {isUserLoading ? (
          <Loader />
        ) : (
          <div className="trustbadge-content-container">
            <div className="edit-profile-content-heading">
              <img
                className="trustbadge-icon"
                src={images.trustBadgeIcon}
                alt="img"
              />

              <h3 className="edit-profile-content-heading-title trust-badge-title">
                Verify Your Profile & Get the trust badge
              </h3>
              <h5 className="edit-profile-content-heading-subtitle">
                You have already submitted proof of your identification. If you
                do not hear from us within 24 hours, please send an email with
                your username or user ID to
                <span> support@noblemarriage.com</span>
              </h5>
            </div>
            {user?.trustbadge?.length > 0 ? (
              <DocumentView
                trustbadge={user?.trustbadge}
                deleteTrustBadge={deleteTrustBadge}
              />
            ) : (
              <DocumentUpload />
            )}

            <Spacer height="60px" />
            <div className="trustbadge-footer">
              <div className="trustbadge-document-verified">
                <img src={images.documentVerified} alt="Document Verified" />
              </div>
              <div className="trustbadge-footer-content">
                <p>
                  This information you provide is only used for profile
                  verification and is not shared with other members or third
                  parties.
                </p>
              </div>
            </div>
            <Spacer height="17px" />
          </div>
        )}
      </div>
    </UserProfileLayout>
  );
};

export default EditTrustBadge;








